<template>
  <div class="p-root-portal" :style="styleList">
    <slot></slot>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import _ from '../../utils';

  export default Vue.extend({
    data: () => ({
      nestDepth: 1,
    }),
    computed: {
      styleList(): Record<string, any> {
        return {
          // Above all else
          'z-index': this.nestDepth + 1000,
        };
      },
    },
    mounted() {
      this.nestDepth = this.getDepth();
      const appEl = _.component.getAppEl()!;
      appEl.insertBefore(this.$el, appEl.firstChild);
    },
    destroyed() {
      const appEl = _.component.getAppEl()!;
      // appEl could already be cleared, for example on page change
      if (appEl && appEl.contains(this.$el)) {
        appEl.removeChild(this.$el);
      }
    },
    methods: {
      getDepth() {
        let depth = 1;
        let parent = this.$parent;
        while (parent) {
          const isRootPortal = parent.$vnode?.tag?.includes('p-root-portal');
          if (isRootPortal) {
            depth += 1;
          }
          parent = (parent as Vue).$parent;
        }
        return depth;
      },
    },
  });
</script>
